import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  deleteInboxMessage,
  getInboxMessages,
  getInboxMessageUnreadCount,
  getPublicInboxMessages,
  INBOX_MESSAGES_TAGS,
  INBOX_MESSAGES_UNREAD_COUNT_TAGS,
  pinInboxMessage,
  PUBLIC_INBOX_MESSAGES_TAGS,
  updateInboxMessageReadFlag,
} from './endpoints';

export const inboxApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      deleteInboxMessage: deleteInboxMessage(builder),
      getInboxMessages: getInboxMessages(builder),
      getInboxMessageUnreadCount: getInboxMessageUnreadCount(builder),
      updateInboxMessageReadFlag: updateInboxMessageReadFlag(builder),
      getPublicInboxMessages: getPublicInboxMessages(builder),
      pinInboxMessage: pinInboxMessage(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [INBOX_MESSAGES_TAGS, INBOX_MESSAGES_UNREAD_COUNT_TAGS, PUBLIC_INBOX_MESSAGES_TAGS],
  });

export const {
  useDeleteInboxMessageMutation,
  useGetInboxMessagesQuery,
  useGetInboxMessageUnreadCountQuery,
  useLazyGetInboxMessagesQuery,
  useUpdateInboxMessageReadFlagMutation,
  useGetPublicInboxMessagesQuery,
  useLazyGetPublicInboxMessagesQuery,
  usePinInboxMessageMutation,
} = inboxApi;
